import React from 'react'
import { useData } from 'vike-react/useData'

import { BlogIndexLayout } from '../../blog/Layout'
import type { Data } from './+data'

export default function BlogCategoryPage() {
  const { blogPosts, selectedCategory } = useData<Data>()

  return (
    <BlogIndexLayout
      selectedCategory={selectedCategory}
      blogPosts={blogPosts}
    />
  )
}
